import styled from "styled-components"; 

export const Container = styled.div `
    width: 100%;
    height: 100%;
    background-color: var(--color-white);
    border-radius: 8px;
    @media  (max-width: 500px){
        width: 100%;
    }
    button {
        width: 290px;
        height: 40px;
        border: 2px solid var(--color-latex30);
        color: var(--color-latex30);
        border-radius: 8px;
        background: transparent;
        font-size: 18px;
        margin: 15px;
    }
    .cruz {
        font-size:  18px ;
    }
`; 


export const Top = styled.div`
    height: 54px;
    background: var(--color-latex30);
    color:  var(--color-white);
    display: flex;
    justify-content: center;
    align-items: center;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    span {
        font-weight: bold;
        font-size: 18px;
    }
`;


export const Body = styled.div`
    height: 65%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow-x: hidden;
    overflow-y: scroll;
    span {
        margin-top: 10px;
        text-align: center;
        width: 80%;
        font-size: 16px;
        max-height: 350px;
    }
`;